import { Security2FAType } from '@/shared/types/auth';

export const DEFAULT_SELECTED_TWO_FACTOR_AUTH_METHOD =
  Security2FAType.AUTHENTICATION_APP;

export const AUTHENTICATOR_APP_LINKS = {
  'google-auth-app-ios': {
    href: 'https://apps.apple.com/us/app/google-authenticator/id388497605',
    target: '_blank',
  },
  'google-auth-app-android': {
    href: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
    target: '_blank',
  },
} as const;

export const US_CA_PHONE_NUMBER_MASK = '(###) ###-####';

export const US_CA_INTERNATIONAL_PHONE_NUMBER_PREFIX = '+1';

// The length includes the +1 country code: (987) 654-3210 --> +19876543210
export const US_CA_INTERNATIONAL_PHONE_NUMBER_LENGTH = 12;
